export type ClassValue = string | number | false | null | undefined;

/**
 * Joins class names, dropping falsy values so `cond && "class"` reads cleanly.
 *
 * There is no Tailwind conflict resolution here (no tailwind-merge): later
 * classes do not beat earlier ones, because CSS wins by stylesheet order, not
 * attribute order. Override component styling through its variant props.
 */
export function cn(...inputs: ClassValue[]): string {
  let result = "";
  for (const input of inputs) {
    if (!input) continue;
    result = result ? `${result} ${input}` : String(input);
  }
  return result;
}
